import MapTabs from './MapTabs'

export default MapTabs
